import React, { useState } from 'react';
import { connect } from 'react-redux';
import { EaseModal } from '../../../libs/EaseModal';
import { QuickTransferForm } from '../Forms';
import { Text1 } from '../../../styles';
import { alertify, handleApiExceptions } from '../../../app_methods';
import { QuickTransfer } from '../../../models';
import { OTPModal } from '../OTPModal';
import { MerchantService } from '../../../services';
import { updateCurrentUserAction } from '../../../redux/actions';


const quickTransfer = new QuickTransfer();

const QuickTransferModalComponent = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isVerifying, setIsVerifying] = useState(false);
    const [showOTPModal, setShowOTPModal] = useState(false);

    const validateQuickTransfer = async () => {
        setIsLoading(true);
        const response = await quickTransfer.validate();
        
        if (!response.success) {
            
            setIsLoading(false);
            handleApiExceptions(response)
            return;
        }
        setIsLoading(false);
        if (props.current_user.bpo) {
            initiateQuickTransfer();
            return;
        }
        toggleOTPModal();
        generateTransferOTP();
    };

    const generateTransferOTP = () => {
        setIsLoading(true);
        MerchantService.generate_otp({
            type: "transfer",
            send_email: true,
            send_sms: true,
            amount: quickTransfer.amount,
            payment_mode: quickTransfer.payment_mode,
            beneficiary_name: quickTransfer.beneficiary_name
        }).then((response) => {
            if (response.success) {
                setIsLoading(false);
            }
            else {
                setIsLoading(false);
                handleApiExceptions("OTP generation failed.");
            }
        }).catch((error) => {
            setIsLoading(false);
            handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
        });
    };

    const verifyOTP = (otp) => {
        setIsVerifying(true);
        MerchantService.verify_otp({ otp }).then((response) => {
            if (response.success) {
                if (response.data.verified) {
                    toggleOTPModal();
                    initiateQuickTransfer();
                }
                else handleApiExceptions("OTP is incorrect.");
            }
            else handleApiExceptions("OTP verification failed.");
            setIsVerifying(false);
        }).catch((error) => {
            setIsVerifying(false);
            handleApiExceptions({ success: false, status: (error.response && error.response.status) || 400 });
        });
    };

    const initiateQuickTransfer = async () => {
        setIsLoading(true);
        const response = await quickTransfer.initiate();
        if (!response.success) {
            setIsLoading(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", response.data.message, "success");
        props.toggleTransferModal();
        setIsLoading(false);
        props.onSuccess();
        fetchMerchantInfo();
        quickTransfer.reset();
    };

    const toggleOTPModal = () => {
        setShowOTPModal(!showOTPModal);
    };

    const fetchMerchantInfo = () => {
        MerchantService.fetch().then((response) => {
            if (response.success) props.updateCurrentUser(response.data.merchant);
        });
    };

    return (
        <EaseModal
            width={550}
            title={false}
            visible={props.visible}
            onCancel={props.toggleTransferModal}
            centered
            hideFooter
            destroyOnClose
        >
            <Text1 className="d-block mb-4" strong>Instant Transfer</Text1>
            <QuickTransferForm
                onSubmit={(values) => {
                    quickTransfer.set(values);
                    validateQuickTransfer();
                }}
                loading={isLoading}
                submitText="Transfer"
            />
            <OTPModal
                visible={showOTPModal}
                onCancel={toggleOTPModal}
                verifyOTP={verifyOTP}
                loading={isVerifying}
                generateOTP={generateTransferOTP}
            />
        </EaseModal>
    )
};

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

const QuickTransferModal = connect(mapStateToProps, mapDispatchToProps)(QuickTransferModalComponent);


export { QuickTransferModal };